import { Button } from '@mui/material'
import { styled } from '@mui/material/styles'

export const ThemeButtonWrapper = styled(Button)(({ theme }) => ({
  background: theme.palette.background.secondary,
  padding: '2px',
  fontSize: '12px',
  borderRadius: '20px',
  height: '28px',
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
  marginRight: '18px',
  '&:hover': {
    background: theme.palette.background.secondary,
  },
  '& .theme-text': {
    marginLeft: theme.palette.mode === 'light' ? '0px' : '8px',
    marginRight: theme.palette.mode === 'light' ? '8px' : '0px',
    fontSize: '12px',
    fontWeight: 600,
  },
}))
